import { type FeatureFlag, FlagState } from '@kalos/kalos-rpc';

import { localStorageManager } from '../tools/storageManager';

/**
 * The prod build. The dev site and the local dev server build in development
 * mode (pipeline-scripts/build.sh builds production only for master), and
 * tests run in test mode.
 */
export const IS_PROD = import.meta.env.MODE === 'production';

/**
 * A local override from localStorage['kalos.flagOverrides'], for example
 * {"job-details.follow-up-flow": false} to see the old UI on the dev site.
 * The prod build never reads it.
 */
export function readOverride(key: string): boolean | undefined {
  if (IS_PROD) return undefined;
  const value = localStorageManager.get('kalos.flagOverrides')?.[key];
  return typeof value === 'boolean' ? value : undefined;
}

/**
 * Whether a flag reads as on. Outside prod every flag is on, so QA always
 * runs the new code. In prod only a row that is on counts: no row, a failed
 * read and an unknown key all run the old code. A retired row keeps its last
 * value until the sweep purges it.
 */
export function evaluateFlag(
  rows: ReadonlyMap<string, FeatureFlag>,
  key: string,
  isProd: boolean = IS_PROD,
): boolean {
  return readOverride(key) ?? (!isProd || rows.get(key)?.state === FlagState.ON);
}
